import { AppConfig } from 'AppSrc/core/config/app-config';
import { postRESTQuery } from 'AppSrc/core/queries/axios-queries';


const addSignature = (signatureObj) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.approvals.approve}`;

  return postRESTQuery(endpoint, signatureObj)
    .then(() => true)
    .catch((error) => error);
};

const addSignatures = (approvalSigntures) => {
  const promises = approvalSigntures.map((signatureObj) => addSignature(signatureObj));

  return Promise.all(promises)
    .then(() => true)
    .catch((error) => error);
};




export {
  addSignature,
  addSignatures,
};

